"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SAVE_CHARACTER = exports.SAVE_CHARACTER = "SAVE_CHARACTER";
var HINT = exports.HINT = "HINT";
var FEEDBACK = exports.FEEDBACK = "FEEDBACK";
var GO_PLAY = exports.GO_PLAY = "GO_PLAY";
var INVITE_PLAYER = exports.INVITE_PLAYER = "INVITE_PLAYER";
var LOAD_CHARACTER = exports.LOAD_CHARACTER = "LOAD_CHARACTER";
var SIGN_UP = exports.SIGN_UP = "SIGN_UP";
var FRIENDS = exports.FRIENDS = "FRIENDS";